export default "__VITE_ASSET__CLu8Mxcm__"